import "lenis/dist/lenis.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { EnquiryProvider } from "@/components/enquiry/EnquiryProvider";
import { InventoryGate } from "@/components/layout/InventoryGate";
import Home from "@/pages/Home";
import UsedCars from "@/pages/UsedCars";
import VehicleDetail from "@/pages/VehicleDetail";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <EnquiryProvider>
          <InventoryGate>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route index element={<Home />} />
              <Route path="used-cars" element={<UsedCars />} />
              <Route path="used-cars/:slug" element={<VehicleDetail />} />
              <Route path="about" element={<About />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          </InventoryGate>
          <Toaster position="top-center" />
        </EnquiryProvider>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
